import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { generateGoogleMapsLink, generateDirectionsLink } from '../../utils/googleMapsUtils';

interface GoogleMapsLinksProps {
  placeId: string;
  address: string;
  showTitle?: boolean;
}

const GoogleMapsLinks: React.FC<GoogleMapsLinksProps> = ({ placeId, address, showTitle = true }) => {
  const { t } = useTranslation();

  if (!placeId || !address) {
    return null;
  }

  return (
    <Box sx={{ mt: 1, mb: 1 }}>
      {showTitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          {t('googleMapsLinks.quickLinks')}:
        </Typography>
      )}
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        <Button
          variant="outlined"
          size="small"
          onClick={() => window.open(generateGoogleMapsLink(placeId), '_blank')}
          sx={{ textTransform: 'none' }}
        >
          {t('googleMapsLinks.viewOnGoogleMaps')}
        </Button>
        <Button
          variant="outlined"
          size="small"
          onClick={() => window.open(generateDirectionsLink(placeId), '_blank')}
          sx={{ textTransform: 'none' }}
        >
          {t('googleMapsLinks.getDirections')}
        </Button>
      </Box>
    </Box>
  );
};

export default GoogleMapsLinks;